import { render } from "./ChevronLeft.vue?vue&type=template&id=8bed5a14"
import script from "./ChevronLeft.vue?vue&type=script&lang=js"
export * from "./ChevronLeft.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__